import { render, staticRenderFns } from "./SelectionStep.vue?vue&type=template&id=36315af4&scoped=true"
import script from "./SelectionStep.vue?vue&type=script&lang=js"
export * from "./SelectionStep.vue?vue&type=script&lang=js"
import style0 from "./SelectionStep.vue?vue&type=style&index=0&id=36315af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36315af4",
  null
  
)

export default component.exports